<script>
import OptionBuilder from './Builder.vue';
export default {
    components: {
        OptionBuilder
    },

    props: {
        disabled: {
            type: Boolean,
            default: false
        }
    },
    
    methods: {
        handleClick() {
            Bus.$emit('selliaOptionBuilderClick', 'SpeechToText');
            Bus.$emit('selliaActionResponse', { type: 'recording', timeout: false });
        },
    }
}
</script>

<template>
    <OptionBuilder 
        :disabled="disabled"
        optionName="Transcrição por voz"
        iconName="PodcastMicrophone" 
        id="Speechtotext"
        bottom="108" 
        @selliaOptionBuilderClickSpeechtotext="handleClick" 
    />
</template>
